module.exports = __webpack_public_path__ + "static/media/mdv.5c797036.svg";